import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { CalendarPlus } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { EVENT_STATUS, fmtDate } from "@/lib/format";
import { Pill } from "@/components/Common";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { PageTitle } from "./AdminLayout";
import { EventForm } from "./EventForm";

const DEFAULT_ROUTES = ["A", "B", "C"].map((c, i) => ({ name: `Route ${c}`, code: c, route_type: "TOP_ROPE", display_order: i, rotation_minutes: 5 }));

export default function Events() {
  const nav = useNavigate();
  const [params] = useSearchParams();
  const [items, setItems] = useState([]);
  const [open, setOpen] = useState(params.get("new") === "1");
  useEffect(() => {
    api.get("/admin/events").then((r) => setItems(r.data.items));
  }, []);
  const create = async (payload) => {
    try {
      const { data } = await api.post("/admin/events", { ...payload, routes: DEFAULT_ROUTES });
      toast.success("Event dibuat (draft) dengan 3 jalur default.");
      nav(`/admin/events/${data.id}`);
    } catch (e) {
      toast.error(errMsg(e));
    }
  };
  return (
    <div>
      <PageTitle title="Event" desc="Buat, publikasikan, dan tutup event climbing.">
        <Button className="rounded-full" onClick={() => setOpen(true)} data-testid="create-event-button"><CalendarPlus className="mr-1.5 h-4 w-4" /> Buat Event</Button>
      </PageTitle>
      <div className="overflow-x-auto rounded-2xl bg-white ring-1 ring-[#1A3323]/10">
        <Table data-testid="events-table">
          <TableHeader><TableRow><TableHead>Event</TableHead><TableHead>Tanggal</TableHead><TableHead>Status</TableHead><TableHead>Jalur</TableHead><TableHead>Check-in</TableHead><TableHead>Tiket</TableHead><TableHead>Selesai</TableHead></TableRow></TableHeader>
          <TableBody>
            {items.map((e) => (
              <TableRow key={e.id} className="cursor-pointer" onClick={() => nav(`/admin/events/${e.id}`)} data-testid={`event-row-${e.id}`}>
                <TableCell className="font-semibold text-[#1A3323]">{e.name}<div className="text-xs font-normal text-muted-foreground">{e.location}</div><div className="text-xs font-normal text-[#3D6F4B]">{e.event_type === "PAID" ? `Berbayar · Rp${(e.price || 0).toLocaleString("id-ID")}` : "Komunitas"}</div></TableCell>
                <TableCell>{fmtDate(e.date)}<div className="text-xs text-muted-foreground">{e.start_time}–{e.end_time}</div></TableCell>
                <TableCell><Pill className={EVENT_STATUS[e.status].cls}>{EVENT_STATUS[e.status].label}</Pill></TableCell>
                <TableCell>{e.route_count}</TableCell>
                <TableCell className="font-mono">{e.checkin_count}/{e.participant_quota ?? "∞"}</TableCell>
                <TableCell className="font-mono">{e.tickets_used}/{e.ticket_quota ?? "∞"}</TableCell>
                <TableCell className="font-mono">{e.completed}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </div>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="max-h-[92vh] max-w-2xl overflow-y-auto" data-testid="create-event-dialog">
          <DialogHeader><DialogTitle>Buat Event</DialogTitle></DialogHeader>
          <EventForm onSubmit={create} submitLabel="Buat Event" />
        </DialogContent>
      </Dialog>
    </div>
  );
}
